import { OrganizationPickerModule } from '@app/sidebar-layout/components/organization-picker/organization-picker.module';
import { InAppNotificationsModule } from '@modules/in-app-notifications/in-app-notifications.module';
import { SidebarComponent } from '@app/sidebar-layout/components/sidebar/sidebar.component';
import { SidebarLayoutComponent } from '@app/sidebar-layout/sidebar-layout.component';
import { ClipboardCopyModule } from '@shared/clipboard-copy/clipboard-copy.module';
import { HeaderComponent } from './components/header/header.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { RouterModule } from '@angular/router';
import { CommonModule, NgOptimizedImageModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SupportRequestModule } from '../support-request';
import { ModuleFederationToolsModule } from '@angular-architects/module-federation-tools';
import { MainLogoModule } from '@app/infrastructure/components/main-logo/main-logo.module';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		BsDropdownModule,
		OrganizationPickerModule,
		InAppNotificationsModule,
		SupportRequestModule,
		MatExpansionModule,
		ClipboardCopyModule,
		ModuleFederationToolsModule,
		NgOptimizedImageModule,
		MainLogoModule,
	],
	declarations: [ SidebarLayoutComponent, SidebarComponent, HeaderComponent ],
})
export class SidebarLayoutModule {
}
